module.exports = __webpack_public_path__ + "static/img/Turki.d61837c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Turki.png
// module id = 6iZ8
// module chunks = 1